import moment from "moment";

function getLessonsByClub(
  devPort,
  clubId,
  setUpcomingLessons,
  proMapping,
  startDate,
  endDate
) {
  const fetchStartDate = startDate
    ? startDate
    : moment(moment().format("YYYY-MM-DD") + "T00:00")
        .utc()
        .format("YYYY-MM-DDTHH:mm");
  const fetchEndDate = endDate
    ? endDate
    : moment(fetchStartDate).add(7, "days").format("YYYY-MM-DDTHH:mm");
  fetch(
    devPort + "event_list/" + clubId + "/" + fetchStartDate + "/" + fetchEndDate
  )
    .then((response) => {
      console.log(response.json);
      return response.json();
    })
    .then((data) => {
      console.log("Inside the fc");
      console.log(data);
      let newLessons = [];
      var dayLessons = {};
      var dayTournamentLessons = {};
      if (data) {
        data.map((lesson) => {
          let dateOfLesson;

          dateOfLesson = moment(lesson[4]).format("MM-DD-YYYY");

          if (!dayLessons[dateOfLesson]) {
            dayLessons[dateOfLesson] = [];
          }
          //If not a tournament, add it right away
          if (!lesson[13]) {
            dayLessons[dateOfLesson].push({
              id: lesson[1],
              pro: proMapping[lesson[6]],
              proId: lesson[6],
              slots: lesson[7],
              available: lesson[7] - lesson[8],
              time: moment(lesson[4]).format("HH:mm"),
              date: moment(lesson[4]).format("dddd MMMM Do YYYY, HH:mm"),
              raw_date: moment(lesson[4]),
              lessonPrice: lesson[9] !== "null" ? lesson[9] : null,
              event_type: lesson[0],
              field_location: lesson[2],
              game_type: lesson[11],
              manager_notes: lesson[10],
              tournament_name: lesson[13],
              leagues: [],
              divisions:
                lesson[17] && lesson[17] !== "[null]"
                  ? JSON.parse(lesson[17])
                  : [],
            });
          } else {
            //If it is a tournament, group the event with same tournament name and date first
            if (!dayTournamentLessons[dateOfLesson]) {
              dayTournamentLessons[dateOfLesson] = {};
            }
            const tournamentGatherKey = lesson[18]; // lesson[13] + "____" + dateOfLesson;
            console.log("tournamentGatherKey", tournamentGatherKey);
            if (!dayTournamentLessons[dateOfLesson][tournamentGatherKey]) {
              dayTournamentLessons[dateOfLesson][tournamentGatherKey] = {
                id: lesson[18],
                pro: proMapping[lesson[6]],
                proId: lesson[6],
                slots: lesson[7],
                available: lesson[7] - lesson[8],
                time: moment(lesson[4]).format("HH:mm"),
                date: moment(lesson[4]).format("dddd MMMM Do YYYY, HH:mm"),
                raw_date: moment(lesson[4]),
                lessonPrice: lesson[9] !== "null" ? lesson[9] : null,
                event_type: lesson[0],
                field_location: lesson[2],
                game_type: lesson[11],
                manager_notes: lesson[10],
                tournament_name: lesson[13],
                end_date: moment(lesson[16]),
                leagues: [
                  {
                    league_name: lesson[14],
                    tournament_id: lesson[1],
                    handicap: lesson[15],
                    signups_open: lesson[12],
                    team_maximum: 10,
                  },
                ],
              };
            } else {
              dayTournamentLessons[dateOfLesson][
                tournamentGatherKey
              ].leagues.push({
                league_name: lesson[14],
                handicap: lesson[15],
                tournament_id: lesson[1],
                signups_open: lesson[12],
                team_maximum: 10,
              });
            }
          }
          return null;
        });
      }
      console.log("dayTournamentLessons", dayTournamentLessons);
      //Add the tournaments to the dayLessons
      Object.keys(dayTournamentLessons).forEach((dateOfLesson) => {
        Object.keys(dayTournamentLessons[dateOfLesson]).forEach(
          (tournamentGatherKey) => {
            dayLessons[dateOfLesson].push(
              dayTournamentLessons[dateOfLesson][tournamentGatherKey]
            );
          }
        );
      });
      if (Object.keys(dayLessons).length > 0) {
        console.log(dayLessons);
        Object.keys(dayLessons)
          .sort(
            (a, b) => moment(a, "MM-DD-YYYY") - moment(b, "MM-DD-YYYY")
          )
          .forEach((dateOfLesson) => {
            newLessons.push({
              day: moment(dateOfLesson, "MM-DD-YYYY").format("dddd"),
              date: dateOfLesson,
              lessons: dayLessons[dateOfLesson].sort(
                (a, b) => moment(a.time, "HH:mm") - moment(b.time, "HH:mm")
              ),
            });
          });
        console.log("I get here");
        console.log(newLessons);
        setUpcomingLessons(newLessons);
      } else {
        console.log("No lessons found");
        setUpcomingLessons([]);
      }
    })
    .catch(() => setUpcomingLessons([]));
}

export default getLessonsByClub;
